module.exports = __webpack_public_path__ + "img/person-plus-fill.51f51d10.svg";